module.exports = __webpack_public_path__ + "img/blue_146.2dcb33e5.png";